import { ChangeProjectionService } from '@analysis/domain';
import { ListForAssetInSamplePayload, ListRoisResponse, type RoiRepository, type RoiChangesRepository } from '../../ports';

export class ListAssetRoisUseCase {
  constructor(private readonly rois: RoiRepository, private readonly changes: RoiChangesRepository) {}

  public async execute(payload: ListForAssetInSamplePayload): Promise<ListRoisResponse> {
    const result = await this.rois.listForAssetInSample(payload);

    const pendingChanges = await this.changes.getForSampleAssetAndCreator(
      payload.sampleId,
      payload.assetId,
      payload.creatorId
    );

    if (pendingChanges.length === 0) return result;

    const baseline = new Map(result.items.map((r) => [r.id, r]));
    const projected = ChangeProjectionService.projectChanges(baseline, pendingChanges);

    return { items: Array.from(projected.values()), roiFindings: result.roiFindings, nextToken: result.nextToken };
  }
}
